import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntlService {

  constructor() { }

  getLocaleId() {
    return 'pt-BR';
  }
}
